/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoeffectgradient4Inputs */

const en_aiflowphotoeffectgradient4 = /** @type {(inputs: Aiflowphotoeffectgradient4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark fade`)
};

const de_aiflowphotoeffectgradient4 = /** @type {(inputs: Aiflowphotoeffectgradient4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkler Verlauf`)
};

/**
* | output |
* | --- |
* | "Dark fade" |
*
* @param {Aiflowphotoeffectgradient4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoeffectgradient4 = /** @type {((inputs?: Aiflowphotoeffectgradient4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoeffectgradient4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoeffectgradient4(inputs)
	return de_aiflowphotoeffectgradient4(inputs)
});
export { aiflowphotoeffectgradient4 as "aiFlowPhotoEffectGradient" }